import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MaterialModule } from './material.module';
import { LoaderComponent } from './loader/loader.component';
import { BannerCarouselComponent } from './components/banner-carousel/banner-carousel.component';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { CommentsGridComponent } from './components/comments-grid/comments-grid.component';
import { BannerGridComponent } from './components/banner-grid/banner-grid.component';
import { MaxLengthPipe } from './pipes/max-length.pipe';
import { AddQuotesPipe } from './pipes/add-quotes.pipe';
import { CardsGridComponent } from './components/cards-grid/cards-grid.component';
import { EditBenefitDialogComponent } from './alerts/benefits/edit-benefit-dialog/edit-benefit-dialog.component';
import { ActionsBenefitsInstitutionComponent } from './alerts/benefits/actions-benefits-institution/actions-benefits-institution.component';
import { ActionsBenefitsCategoriesComponent } from './alerts/benefits/actions-benefits-categories/actions-benefits-categories.component';
import { LikeCouponCarouselComponent } from './components/like-coupon-carousel/like-coupon-carousel.component';
import { QuillModule } from 'ngx-quill';
import { HeaderLinksGridComponent } from './components/header-links-grid/header-links-grid.component';
import { RentBenefitsComponent } from './components/rent-benefits/rent-benefits.component';
import { ActionsBenefitsRentsComponent } from './alerts/benefits/actions-benefits-rents/actions-benefits-rents.component';
import { RentInfoComponent } from './components/rent-info/rent-info.component';
import { ActionsRentInfoComponent } from './alerts/actions-rent-info/actions-rent-info.component';
import { EditSliderComponent } from './alerts/slider/edit-slider/edit-slider.component';
import { DeleteStrPipe } from './pipes/delete-str.pipe';
import { BlogGridComponent } from './components/blog-grid/blog-grid.component';
import { CreateBlogComponent } from './alerts/blog/create-blog/create-blog.component';
import { SafeDomPipe } from './pipes/safe-dom.pipe';
import { ActionsDirectoryComponent } from './alerts/actions-directory/actions-directory.component';
import { CreateSliderComponent } from './alerts/slider/create-slider/create-slider.component';
import { CreateVsCardComponent } from './alerts/cards/create-vs-card/create-vs-card.component';
import { EditVsCardComponent } from './alerts/cards/edit-vs-card/edit-vs-card.component';
import { CreateCommentComponent } from './alerts/comments/create-comment/create-comment.component';
import { EditCommentComponent } from './alerts/comments/edit-comment/edit-comment.component';
import { CreateBannerComponent } from './alerts/banners/create-banner/create-banner.component';
import { EditBannerComponent } from './alerts/banners/edit-banner/edit-banner.component';
import { CreateProductServiceComponent } from './alerts/product-services/create-product-service/create-product-service.component';
import { EditProductServiceComponent } from './alerts/product-services/edit-product-service/edit-product-service.component';
import { CreateUrlCardComponent } from './alerts/cards/create-url-card/create-url-card.component';
import { EditUrlCardComponent } from './alerts/cards/edit-url-card/edit-url-card.component';
import { EditSectionTitleComponent } from './alerts/edit-section-title/edit-section-title.component';
import { EditLinkComponent } from './alerts/header-links/edit-link/edit-link.component';
import { CreateLinkComponent } from './alerts/header-links/create-link/create-link.component';
import { CreateBlogSectionComponent } from './alerts/blog/create-blog-section/create-blog-section.component';
import { EditMetaDataComponent } from './alerts/seo/edit-meta-data/edit-meta-data.component';
import { EditTitleDialogComponent } from './alerts/edit-title-dialog/edit-title-dialog.component';
import { CreateBannerDialogComponent } from './alerts/create-banner-dialog/create-banner-dialog.component';
import { MetaInformationComponent } from './components/meta-information/meta-information.component';
import { RequerimentChangeStatusComponent } from './alerts/requeriment-change-status/requeriment-change-status.component';
import { ShowRequirementInformationComponent } from './alerts/show-requirement-information/show-requirement-information.component';
import { FooterGridComponent } from './components/footer-grid/footer-grid.component';
import { EditFooterLogoComponent } from './alerts/footer/edit-footer-logo/edit-footer-logo.component';
import { EditFooterSectionComponent } from './alerts/footer/edit-footer-section/edit-footer-section.component';
import { EditFooterTextComponent } from './alerts/footer/edit-footer-text/edit-footer-text.component';
import { EditFooterContactComponent } from './alerts/footer/edit-footer-contact/edit-footer-contact.component';
import { OurSupportInformationComponent } from './alerts/our-support-information/our-support-information.component';
import { InsertPdfComponent } from './alerts/benefits/insert-pdf/insert-pdf.component';
import { MemoryYearComponent } from './alerts/memory-year/memory-year.component';
import { InformationActionsComponent } from './alerts/information-actions/information-actions.component';
import { MultiCardActionsComponent } from './alerts/multi-card-actions/multi-card-actions.component';
import { ShowContactInfoComponent } from './alerts/show-contact-info/show-contact-info.component';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MultiInformationActionsComponent } from './alerts/multi-information-actions/multi-information-actions.component';
import { MultiReportActionsComponent } from './alerts/multi-report-actions/multi-report-actions.component';
import { EditVirtualCardComponent } from './alerts/cards/edit-virtual-card/edit-virtual-card.component';
import { EditTitlesComponent } from './alerts/virtualAgency/edit-titles/edit-titles.component';
import { FileManagerAlertComponent } from './alerts/file-manager-alert/file-manager-alert.component';
import { RequestsProceduresAlertComponent } from './alerts/requests-procedures-alert/requests-procedures-alert.component';
import { RequestsProceduresDetailComponent } from './alerts/requests-procedures-detail/requests-procedures-detail.component';
import { RequestsProceduresDetailRequestComponent } from './alerts/requests-procedures-detail-request/requests-procedures-detail-request.component';
import { ProfileModalEditorComponent } from './alerts/profile-modal-editor/profile-modal-editor.component';
import { ProfileModalRolesComponent } from './alerts/profile-modal-roles/profile-modal-roles.component';
import { AddRequirementsReclaimComponent } from './alerts/add-requirement-reclaim/add-requirement-reclaim.component';
import { RequierementDetailComponent } from './alerts/add-requirement-reclaim/requirement-detail/requirement-detail.component';
import { UserDetailComponent } from './alerts/add-requirement-reclaim/user-detail/user-detail.component';
import { ReclaimDetailComponent } from './alerts/add-requirement-reclaim/reclaim-detail/reclaim-detail.component';
import { FMXInfoComponent } from './components/fmx-info/fmx-info.component';

@NgModule({
  declarations: [
    MaxLengthPipe,
    LoaderComponent,
    BannerCarouselComponent,
    CommentsGridComponent,
    BannerGridComponent,
    AddQuotesPipe,
    CardsGridComponent,
    EditBenefitDialogComponent,
    ActionsBenefitsInstitutionComponent,
    ActionsBenefitsCategoriesComponent,
    LikeCouponCarouselComponent,
    HeaderLinksGridComponent,
    RentBenefitsComponent,
    ActionsBenefitsRentsComponent,
    RentInfoComponent,
    ActionsRentInfoComponent,
    EditSliderComponent,
    DeleteStrPipe,
    BlogGridComponent,
    CreateBlogComponent,
    SafeDomPipe,
    ActionsDirectoryComponent,
    CreateSliderComponent,
    CreateVsCardComponent,
    EditVsCardComponent,
    CreateCommentComponent,
    EditCommentComponent,
    CreateBannerComponent,
    EditBannerComponent,
    CreateProductServiceComponent,
    EditProductServiceComponent,
    CreateUrlCardComponent,
    EditUrlCardComponent,
    EditSectionTitleComponent,
    EditLinkComponent,
    CreateLinkComponent,
    CreateBlogSectionComponent,
    EditMetaDataComponent,
    EditTitleDialogComponent,
    CreateBannerDialogComponent,
    MetaInformationComponent,
    RequerimentChangeStatusComponent,
    ShowRequirementInformationComponent,
    FooterGridComponent,
    EditFooterLogoComponent,
    EditFooterSectionComponent,
    EditFooterTextComponent,
    EditFooterContactComponent,
    OurSupportInformationComponent,
    InsertPdfComponent,
    MemoryYearComponent,
    InformationActionsComponent,
    MultiCardActionsComponent,
    ShowContactInfoComponent,
    MultiInformationActionsComponent,
    MultiReportActionsComponent,
    EditVirtualCardComponent,
    EditTitlesComponent,
    FileManagerAlertComponent,
    RequestsProceduresAlertComponent,
    RequestsProceduresDetailComponent,
    RequestsProceduresDetailRequestComponent,
    ProfileModalEditorComponent,
    ProfileModalRolesComponent,
    AddRequirementsReclaimComponent,
    RequierementDetailComponent,
    UserDetailComponent,
    ReclaimDetailComponent,
    FMXInfoComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MaterialModule,
    SweetAlert2Module,
    PerfectScrollbarModule,
    QuillModule.forRoot()
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PerfectScrollbarModule,
    RouterModule,
    MaterialModule,
    LoaderComponent,
    BannerCarouselComponent,
    SweetAlert2Module,
    CommentsGridComponent,
    BannerGridComponent,
    MaxLengthPipe,
    AddQuotesPipe,
    CardsGridComponent,
    LikeCouponCarouselComponent,
    EditSliderComponent,
    DeleteStrPipe,
    HeaderLinksGridComponent,
    RentBenefitsComponent,
    RentInfoComponent,
    BlogGridComponent,
    CreateBlogComponent,
    SafeDomPipe,
    CreateBlogSectionComponent,
    EditMetaDataComponent,
    EditTitleDialogComponent,
    CreateBannerDialogComponent,
    MetaInformationComponent,
    RequerimentChangeStatusComponent,
    ShowRequirementInformationComponent,
    FooterGridComponent,
    EditFooterLogoComponent,
    EditFooterSectionComponent,
    EditFooterTextComponent,
    EditFooterContactComponent,
    InsertPdfComponent,
    ShowContactInfoComponent,
    EditTitlesComponent,
    AddRequirementsReclaimComponent,
    RequierementDetailComponent,
    UserDetailComponent,
    ReclaimDetailComponent,
    FMXInfoComponent,
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'es-PE' },
  ],
  entryComponents: [],
})
export class SharedModule {
}
